import { render, staticRenderFns } from "./IvyLogins.vue?vue&type=template&id=2fada85d&"
import script from "./IvyLogins.vue?vue&type=script&lang=js&"
export * from "./IvyLogins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports